<template src="./Index.html">
</template>

<script>
  import axios from 'axios'
  import list from "@/components/List"
  import moment from 'moment'
  import loading from '@/components/PageLoader'
  import ConfirmationModal from '@/components/global/ConfirmationModal'
  import CoreAssignModal from '@/components/core/CoreAssignModal'
  import * as spaApi from "@/spaApi.js"
  import {integrateLinks, targets} from "@/constants";

  axios.defaults.headers.common['Pragma'] = 'no-cache';

export default {
  name: 'integrations',
  components: {
    list,
    loading,
    'confirmation-modal': ConfirmationModal,
    'assign-modal': CoreAssignModal
  },
  data() {
    return {
      isLoading: true,
      actions: {
        href: '',
        tooltip: '',
        icon: ''
      },
      breadcrumbs: [
        { text: this.$t("Integrations"), active: true }
      ],
      isAdmin: false,
      assignedModalItemId: '',
      assignedModalUserId: '',
      assignedUser: '',
      assignData: [],
      currentListItemDIN: '',
      searchingBU: true,
      tableList: {
        mainHeader: this.$t("Integrations"),
        buttonLabel: this.$t("CreateNewClient"),
        redoLabel: this.$t("RefreshData"),
        filterOn: [],
        filter: null,
        dataArray: [],
        currentPage: 1,
        fields: [
          { key: "name", label: this.$t("Name"), sortable: true },
          { key: "targetSystem", label: this.$t("Target"), sortable: true },
          { key: "businessUnitName", label: this.$t("BusinessUnit"), sortable: true },
          { key: "assignedTo", label: this.$t("AssignedTo"), sortable: true },
          { key: "createdBy", label: this.$t("InitiatedBy"), sortable: true },
          { key: "createdOnDisplay", label: this.$t("CreatedOn"), sortable: true },
          { key: "actions", label: this.$t("Actions"), sortable: false, thClass: 'action-items' }
        ]
      }
    };
  },
  computed: {
    items() {
    return this.keyword
      ? this.tableList.dataArray.filter(item =>
        item.name.includes(this.keyword) ||
        item.createdOnDisplay.includes(this.keyword) ||
        item.targetSystem.includes(this.keyword) ||
        item.assignedTo.includes(this.keyword) ||
        item.createdBy.includes(this.keyword))
      : this.tableList.dataArray
    },
  },

  mounted() {
    this.loadPageData();
  },
  methods: {
    loadPageData(){
      this.isLoading = true;
      let app = this;

      // May need to update this call to get a dynamics role rather than a user role. TBD. Currently hardcoded to true
      axios.get(`/users/current/is-admin-role`)
        .then((response) => {
          const {
            data,
            status
          } = response;
          if (status === 200) {
            this.isAdmin = data;
            this.tableList.isAdmin = data;
          } else {
            // something went wrong
          }

          return axios.get(`integrations`).then(response => {
            app.isLoading = false;
            for (var item in response.data) {
              response.data[item].createdOnDisplay = moment.utc(response.data[item].createdOn).format('MM/DD/YYYY');
              response.data[item].actions = [
                {
                  href: app.$router.resolve({ name: app.resolveProcessLinkByTargetSystem(response.data[item].targetSystem), params: { integrationId: response.data[item].integrationID,  din: response.data[item].dynamicsInstanceName } }).href,
                  tooltip: this.$t("ProcessRequest"),
                  icon: 'fa fa-user-circle'
                },
                {
                  href: 'javascript:void(0);',
                  tooltip: this.$t("CancelRequest"),
                  icon: 'fas fa-ban'
                },
                {
                  href: 'javascript:void(0);',
                  tooltip: this.$t("AssignRequest"),
                  icon: 'fa fa-share'
                }
              ]
            }

            app.tableList.dataArray = response.data;

            return (response.data);
          }).catch(error => {
            app.isLoading = false;
            return []
          });
        })
        .catch(error => {
          app.isLoading = false;
          console.log(`An error occurred when confirming if you're an admin:${error}`)
        });

    },
    resolveProcessLinkByTargetSystem(target){
      if(target === targets.bp){
        return integrateLinks.bp;
      }
      return integrateLinks.epic;
    },
    refreshPage(){
      this.loadPageData(true);
    },
    cancelRequest(id) {
      this.$refs.confirmCancelRequest.showConfirmationModal(this.confirmedCancelRequest, null, id);
    },
    tableSortCompare(aRow, bRow, key, sortDesc, formatter, compareOptions, compareLocale) {
      if (key == "createdOnDisplay") {
        return aRow["createdOn"].localeCompare(bRow["createdOn"], compareLocale, compareOptions);
      }

      return null;
    },
    showAssignModal(listItem) {
      this.assignedModalItemId = listItem.integrationID;
      this.currentListItemDIN = listItem.dynamicsInstanceName;
      this.assignedModalUserId = '';
      this.assignedUser = '';
      this.assignData = [];
      this.$bvModal.show('assignRequest');
    },
    confirmedCancelRequest(id) {
      this.isLoading = true;
      let app = this;

      let item = app.tableList.dataArray.find(x => x.integrationID == id);
      axios.put(`integrations/${id}/cancel?din=${item.dynamicsInstanceName}`, null).then(response => {
        app.isLoading = false;
        if (response.status === 200) {
          // remove from list without refreshing data
          app.tableList.dataArray = app.tableList.dataArray.filter(function (el) { return el.integrationID != id });
        }
        return (response.data);
      }).catch(error => {
        app.isLoading = false;
        return false;
      });
    },
    onSearchAssignUser(search, loading) {
      if (!search) { return; }
      loading(true);
      spaApi.getDynamicsUsers(loading, search, this.searchingBU, this.assignedUser, this.currentListItemDIN, this.assignDataGetSet);
    },
    assignDataGetSet(apiData) {
      if (apiData)
        this.assignData = apiData;
      else
        return this.assignData;
    },
    assignUser() {
      this.isLoading = true;
      let app = this;

      if (app.assignedModalUserId != null && app.assignedModalUserId != '') {
        let item = app.tableList.dataArray.find(x => x.integrationID == app.assignedModalItemId);
        // Call assign endpoint
        axios.put(`integrations/${app.assignedModalItemId}/assign/${app.assignedModalUserId}?din=${item.dynamicsInstanceName}`, null).then(response => {
          app.isLoading = false;

          if (response.status === 200) {
            // remove from list without refreshing data
            app.tableList.dataArray = app.tableList.dataArray.filter(function (el) { return el.integrationID != app.assignedModalItemId });
          }
          return (response.data);
        }).catch(error => {
          app.isLoading = false;
          return false;
        });
      }
    }
  }
};
</script>
